"use client";

import dynamic from "next/dynamic";

const EventMap = dynamic(
  () => import("./EventMap").then((m) => m.EventMap),
  { ssr: false, loading: () => <div className="h-full w-full animate-pulse bg-muted" /> },
);

interface Props {
  lat: number;
  lng: number;
  venue?: string;
  district?: string;
}

export function EventMapWrapper(props: Props) {
  return <EventMap {...props} />;
}
